import { InjectionToken } from '@angular/core'
import type { AbstractEditorComponent } from './edit/abstract-editor.component'
import { BusinessObject } from '@lg/shared'
import type { EditorHelperService } from './edit/editor-helpers/editor-helper.service'

export const AbstractEditorComponentInjectionToken = new InjectionToken<
	AbstractEditorComponent<BusinessObject>
>('AbstractEditorComponent')

export const EditorHelperServiceInjectionToken =
	new InjectionToken<EditorHelperService>('EditorHelperService')
